import { render, staticRenderFns } from "./hrd-add-health-profession.vue?vue&type=template&id=71cee7c8&scoped=true"
import script from "./hrd-add-health-profession.vue?vue&type=script&lang=js"
export * from "./hrd-add-health-profession.vue?vue&type=script&lang=js"
import style0 from "./hrd-add-health-profession.vue?vue&type=style&index=0&id=71cee7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cee7c8",
  null
  
)

export default component.exports